<template>
  <div>
    <v-card max-height="700">
      <v-card-title :style="backgroundStarStyle">
        <span class="headline black--text">Import ECI files</span>
        <exo-help-dialog
          :color="'black--text'"
          margin="m-0"
          title="ECI files importation"
        >
          The importation of ECI files is managed from a manual selection of the
          computer path where the data to be imported is stored.
          <br />
          <br />
          The importation process is common to all catalogue analysis missions.
          Importing a file already imported in the past will raise a conflict
          error.
        </exo-help-dialog>
        <v-spacer></v-spacer>
        <v-btn
          icon
          light
          class="m-0"
          v-on:click="closeImportFileDialog()"
          :disabled="importing"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div>
          <v-text-field
            label="Select..."
            v-model="fileName"
            prepend-icon="attach_file"
            v-on:click="openFileFinder()"
          ></v-text-field>
          <input
            ref="inputFile"
            type="file"
            webkitdirectory
            files=""
            multiple
            accept=".eci"
            enctype="multipart/form-data"
            style="display: none"
            @change="getInputFiles"
          />
          <v-row v-if="importing === true">
            <v-col>
              <v-progress-linear v-model="importProgressPercentage" height="25">
                <template v-slot:default="{ value }">
                  <strong>{{ Math.ceil(value) }}%</strong>
                </template>
              </v-progress-linear>
            </v-col>
          </v-row>
          <v-row justify-end>
            <v-btn
              :disabled="isNoImportFile || importing"
              color="primary"
              v-on:click="importItems()"
              >Import</v-btn
            >
          </v-row>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from '../../services/axios'

import Vue from 'vue'
import VueAxios from 'vue-axios'
import errorMixin from '../../mixins/logHandler.js'
Vue.use(VueAxios, axios)

export default {
  name: 'import-ephemerides-file',

  mixins: [errorMixin],

  props: {
    root: Object
  },

  mounted() {},

  watch: {},

  data() {
    return {
      fileName: '',
      files: null,
      importing: false,
      currentUploadedSize: 0,
      totalSize: -1
    }
  },

  computed: {
    ...mapGetters({
      currentUser: 'currentUser'
    }),
    importProgressPercentage() {
      if (this.totalSize > 0) {
        return (this.currentUploadedSize / this.totalSize) * 100
      } else {
        return 0
      }
    },

    backgroundStarStyle() {
      return 'background: #3BE287'
    },
    isNoImportFile() {
      if (this.fileName.length) {
        return false
      } else {
        return true
      }
    }
  },

  methods: {
    closeImportFileDialog() {
      this.root.importFileDialog = false
    },
    getInputFiles(event) {
      const files = event.target.files
      this.fileName = files[0].webkitRelativePath.split('/')[0]
      this.files = files
    },
    openFileFinder() {
      this.$refs.inputFile.click()
    },

    async importItems() {
      let ephemerisDays = []
      this.totalSize = 0
      this.currentUploadedSize = 0
      this.importing = true
      this.$emit('update:importing', true)
      for (let file of this.files) {
        this.totalSize += file.size
      }
      for (let file of this.files) {
        let formData = new FormData()
        let currentDay = file.webkitRelativePath.split('/')[1].slice(-3)
        if (!ephemerisDays.includes(currentDay)) {
          ephemerisDays.push(currentDay)
        }
        let headers = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
        formData.append('eciFile', file)
        await this.$http
          .post(
            '/users/' +
              this.currentUser.id +
              '/' +
              'spmeasurements/storefromfile',
            formData,
            headers
          )
          .catch((error) => {
            this.displayMessage(
              'Measurements creation error.',
              error,
              'notification',
              'error'
            )
          })
          .finally(() => {
            this.currentUploadedSize += file.size
          })
      }
      this.importing = false
      this.$emit('update:importing', false)
      this.files = null
      this.fileName = ''
      this.closeImportFileDialog()
    }
  }
}
</script>
